import { EquipmentLibraryCardData } from "./EquipmentLibraryCard";
import { fullModelName } from "portal/utils/atkEquipment";
import { Implement } from "protos/atk/autotractor";
import { TFunction } from "i18next";
import React from "react";

export function getImplementLibraryCardData(
  t: TFunction,
  implement: Implement
): EquipmentLibraryCardData<Implement> {
  const modelName = fullModelName(t, implement);

  return {
    entity: implement,
    name: implement.name,
    updatedAt: implement.updatedAt,
    secondaryLabel: modelName,
    details: [
      {
        label: t("views.autotractor.equipment.modelName"),
        value: <>{modelName}</>,
      },
    ],
  };
}
